import { Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";

import Notification from "./Notification.vue";

export default Node.create({
  name: "notification",

  group: "block",
  content: "(flexrow* heading* logotypeband* blockquote* paragraph*)+",

  defining: true,

  addCommands() {
    return {
      setNotification: () => ({ commands }) => {
        return commands.wrapIn(this.name);
      },
      toggleNotification: () => ({ commands }) => {
        return commands.toggleWrap(this.name);
      },
      unsetNotification: () => ({ commands }) => {
        return commands.lift(this.name);
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: "notification"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["notification", HTMLAttributes, 0];
  },

  addNodeView() {
    return VueNodeViewRenderer(Notification);
  }
});
